<template>
    <svg :id="id"
         version="1.1"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink"
         :width="width"
         :height="height"
         :viewBox="viewBox"
         x="0px"
         y="0px"
         role="img"
         :class="cssClass">
        <title class="logo__title">
            {{ title }}
        </title>
        <path class="logo__icon logo--ternary-color"
              d="M400.9,125.9l-28.4,28.71L265.59,47.7c-3.45-3.46-7.49-3.98-9.59-3.98s-6.13,0.52-9.59,3.98L47.69,246.42
            c-3.45,3.45-3.96,7.48-3.96,9.58s0.51,6.13,3.97,9.59l20.13,20.13l-28.39,28.72l-20.3-20.3c-21.06-21.06-21.06-55.22,0-76.28
            L217.86,19.14c21.06-21.06,55.22-21.06,76.28,0L400.9,125.9z" />
        <path class="logo__icon logo--ternary-color"
              d="M492.86,294.14L294.14,492.86c-21.06,21.06-55.22,21.06-76.28,0L108.6,383.6l28.39-28.72L246.41,464.3
            c3.46,3.46,7.49,3.98,9.59,3.98c2.1,0,6.14-0.52,9.59-3.98L464.3,265.59c3.46-3.46,3.98-7.49,3.98-9.59s-0.52-6.13-3.98-9.59
            l-22.64-22.64l28.06-28.38l-0.14-0.81l23.28,23.28C513.92,238.92,513.92,273.08,492.86,294.14z" />
        <path class="logo__icon logo--secondary-color"
              d="M266.64,223.73L136.99,354.88L108.6,383.6l-25.86,26.15c-9.57,9.68-26.08,4.52-28.43-8.89l-15.09-86.2
            l0.22-0.22l28.39-28.72l129.26-130.75l63.51,6.82L266.64,223.73z" />
        <path class="logo__icon logo--secondary-dark-color"
              d="M82.74,409.75c-2.08,2.1-4.49,3.47-7.01,4.24l54.83-8.44l-21.96-21.96L82.74,409.75z" />
        <path class="logo__icon logo--primary-color"
              d="M469.72,195.39l-28.06,28.38L311.84,355.08l-63.51-6.82l-6.04-61.94L372.5,154.61l28.4-28.71l25.3-25.6
            c9.57-9.68,26.07-4.52,28.42,8.89l14.96,85.39L469.72,195.39z" />
        <path class="logo__icon logo--primary-dark-color"
              d="M426.2,100.3c2.08-2.1,4.49-3.47,7.01-4.24l-53.86,8.29l21.55,21.55L426.2,100.3z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M632.07,335.1c0,4.53-1.38,8.55-4.13,12.09c-2.76,3.54-8.16,5.31-16.22,5.31c-13.97,0-20.95-5.8-20.95-17.4
            V160.16c0-5.9,1.92-10.13,5.75-12.69c3.83-2.55,8.9-3.83,15.2-3.83c6.09,0,11.01,1.28,14.75,3.83c3.74,2.56,5.61,6.79,5.61,12.69
            V335.1H632.07z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M760.69,193.79c10.23,0,18.73,1.62,25.52,4.87c6.79,3.25,12.63,7.92,17.55,14.01
            c5.11,6.69,8.16,14.12,9.14,22.27c0.98,8.16,1.48,15.88,1.48,23.16v78.18c0,5.71-1.67,9.83-5.01,12.39
            c-3.35,2.55-8.46,3.83-15.34,3.83c-5.9,0-10.77-1.23-14.6-3.69c-3.84-2.46-5.75-6.64-5.75-12.54v-77.3c0-8.65-0.89-14.94-2.66-18.88
            c-1.77-3.93-4.48-6.68-8.11-8.26c-3.64-1.57-8.02-2.36-13.13-2.36c-5.31,0-9.84,0.84-13.57,2.51c-3.74,1.67-6.89,3.74-9.44,6.19
            c-2.56,2.46-4.53,5.07-5.9,7.82c-1.38,2.76-2.36,5.31-2.95,7.67c-0.99,3.54-1.53,7.57-1.62,12.09c-0.1,4.53-0.15,8.36-0.15,11.51
            v58.12c0,6.1-1.62,10.47-4.87,13.12c-3.24,2.66-8.6,3.98-16.08,3.98c-6.1,0-10.91-1.28-14.46-3.83c-3.54-2.56-5.31-6.79-5.31-12.69
            V214.14c0-5.31,1.52-9.63,4.57-12.98c3.05-3.34,8.31-5.02,15.78-5.02c5.11,0,9.63,1.13,13.57,3.39c3.93,2.26,5.9,6.84,5.9,13.72
            v3.54c4.13-6.1,10.08-11.45,17.85-16.08C740.88,196.1,750.08,193.79,760.69,193.79z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M909.38,140.68c5.31,0,10.37,0.4,15.19,1.18c4.82,0.79,9.1,1.97,12.83,3.54c3.74,1.58,6.74,3.69,9,6.34
            s3.39,5.75,3.39,9.29c0,4.33-0.79,7.77-2.36,10.32c-2.36,3.94-6.1,5.9-11.21,5.9c-2.16,0-4.13-0.24-5.9-0.74
            c-1.77-0.49-3.45-1.08-5.02-1.77c-1.58-0.69-3.2-1.28-4.87-1.77s-3.59-0.74-5.75-0.74c-4.53,0-7.92,1.58-10.18,4.72
            c-2.26,3.15-3.39,7.48-3.39,12.98v8.85h21.54c4.13,0,6.98,1.67,8.55,5.02s2.36,6.69,2.36,10.03c0,3.54-0.88,7.13-2.66,10.77
            c-1.77,3.64-4.53,5.46-8.26,5.46H901.1v174.76c0,5.9-1.72,10.13-5.16,12.69c-3.45,2.55-8.31,3.83-14.6,3.83
            c-7.28,0-12.54-1.38-15.79-4.13c-3.24-2.75-4.87-6.79-4.87-12.09V230.07H847.7c-3.34-0.39-5.86-2.36-7.52-5.9
            c-1.67-3.54-2.51-6.98-2.51-10.33c0-3.34,0.83-6.68,2.51-10.03c1.67-3.34,4.28-5.02,7.82-5.02h12.68v-9.44
            c0-6.49,0.98-12.69,2.95-18.59c1.96-5.9,4.91-11.06,8.85-15.49c3.93-4.43,9-7.96,15.19-10.62
            C893.89,142.01,901.12,140.68,909.38,140.68z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M1021.49,193.79c21.43,0,38.5,6.64,51.18,19.91c12.69,13.28,19.03,32.3,19.03,57.09c0,5.71-1.73,9.64-5.16,11.8
            c-3.45,2.17-8.31,3.24-14.61,3.24h-85.55c1.96,24.19,15.05,36.29,39.24,36.29c6.29,0,11.6-1.03,15.93-3.1
            c4.32-2.06,8.06-3.88,11.21-5.46c2.95-1.57,5.7-3.14,8.26-4.72c2.56-1.57,5.61-2.36,9.15-2.36c3.93,0,7.57,1.97,10.91,5.9
            c3.34,3.94,5.02,8.36,5.02,13.28c0,3.54-1.03,6.64-3.1,9.3c-2.06,2.65-5.46,5.46-10.18,8.41c-6.3,3.93-13.82,6.93-22.57,9
            s-17.36,3.1-25.81,3.1c-12.2,0-23.26-1.58-33.19-4.72s-18.34-7.97-25.22-14.46c-6.89-6.49-12.2-14.7-15.93-24.63
            c-3.74-9.93-5.61-21.68-5.61-35.25c0-10.42,1.48-20.6,4.43-30.54c2.95-9.93,7.57-18.73,13.86-26.4s14.31-13.87,24.04-18.59
            C996.56,196.15,1008.11,193.79,1021.49,193.79z M1050.69,255.44c0-3.54-0.59-7.08-1.77-10.62s-3-6.79-5.46-9.74
            c-2.47-2.95-5.56-5.31-9.3-7.08s-8.26-2.65-13.57-2.65c-8.46,0-15.79,2.56-21.98,7.67c-6.2,5.12-9.79,12.59-10.77,22.42H1050.69z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M1198.49,193.79c4.52,0,8.06,0.69,10.62,2.06c2.56,1.38,4.47,3.05,5.75,5.02s2.07,4.04,2.36,6.2
            c0.3,2.17,0.44,4.13,0.44,5.9c0,1.77-0.15,3.69-0.44,5.75c-0.29,2.07-1.03,3.98-2.21,5.75c-1.18,1.77-2.85,3.35-5.02,4.72
            c-2.16,1.38-5.11,2.36-8.85,2.95c-3.94,0.79-7.82,1.58-11.65,2.36c-3.83,0.79-8.02,2.26-12.54,4.43c-6.3,3.15-10.23,8.07-11.8,14.75
            c-1.58,6.69-2.36,14.75-2.36,24.19v57.53c0,6.1-1.58,10.52-4.72,13.28c-3.15,2.75-8.26,4.13-15.34,4.13
            c-13.38,0-20.06-5.8-20.06-17.4V212.96c0-4.32,1.42-8.11,4.27-11.36c2.85-3.24,8.01-4.87,15.49-4.87c5.7,0,10.33,0.99,13.87,2.95
            c3.54,1.97,5.31,5.51,5.31,10.62v6.49c3.93-6.29,8.95-11.7,15.04-16.23C1182.75,196.05,1190.03,193.79,1198.49,193.79z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M1325.64,193.79c10.22,0,18.73,1.62,25.52,4.87c6.78,3.25,12.63,7.92,17.55,14.01
            c5.11,6.69,8.16,14.12,9.15,22.27c0.98,8.16,1.48,15.88,1.48,23.16v78.18c0,5.71-1.67,9.83-5.02,12.39
            c-3.35,2.55-8.46,3.83-15.34,3.83c-5.9,0-10.77-1.23-14.6-3.69c-3.84-2.46-5.76-6.64-5.76-12.54v-77.3c0-8.65-0.88-14.94-2.65-18.88
            c-1.77-3.93-4.48-6.68-8.12-8.26c-3.64-1.57-8.02-2.36-13.12-2.36c-5.31,0-9.84,0.84-13.57,2.51c-3.74,1.67-6.89,3.74-9.44,6.19
            c-2.56,2.46-4.53,5.07-5.9,7.82c-1.38,2.76-2.36,5.31-2.95,7.67c-0.98,3.54-1.53,7.57-1.62,12.09c-0.1,4.53-0.15,8.36-0.15,11.51
            v58.12c0,6.1-1.62,10.47-4.87,13.12c-3.25,2.66-8.61,3.98-16.08,3.98c-6.1,0-10.91-1.28-14.46-3.83c-3.54-2.56-5.31-6.79-5.31-12.69
            V214.14c0-5.31,1.52-9.63,4.58-12.98c3.04-3.34,8.3-5.02,15.78-5.02c5.11,0,9.63,1.13,13.57,3.39c3.93,2.26,5.9,6.84,5.9,13.72v3.54
            c4.13-6.1,10.08-11.45,17.85-16.08C1305.82,196.1,1315.02,193.79,1325.64,193.79z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M1549.55,336.28c0,5.71-1.43,9.83-4.28,12.39c-2.85,2.55-7.72,3.83-14.6,3.83c-5.9,0-10.58-1.23-14.01-3.69
            c-3.45-2.46-5.16-6.64-5.16-12.54v-5.31c-2.16,2.76-4.57,5.51-7.23,8.26c-2.66,2.76-5.9,5.21-9.73,7.38
            c-3.84,2.16-8.31,3.93-13.43,5.31c-5.12,1.37-11.01,2.06-17.7,2.06c-15.54,0-27.78-4.08-36.73-12.24s-13.43-19.03-13.43-32.6
            c0-7.86,1.33-14.55,3.98-20.06c2.66-5.5,6.29-10.13,10.91-13.86c4.62-3.74,10.03-6.69,16.23-8.85c6.19-2.16,12.73-3.83,19.62-5.02
            c7.47-1.37,14.99-2.46,22.57-3.24c7.57-0.78,15.78-1.48,24.63-2.07v-5.6c0-2.95-0.4-5.85-1.18-8.7c-0.79-2.85-2.11-5.46-3.98-7.82
            s-4.48-4.23-7.82-5.61c-3.35-1.37-7.48-2.06-12.39-2.06c-3.15,0-6.05,0.2-8.7,0.59c-2.65,0.4-5.21,1.03-7.67,1.92
            c-2.46,0.89-5.01,2.12-7.67,3.69c-2.66,1.58-5.66,3.44-9,5.61c-2.56,1.77-4.97,3.24-7.23,4.43c-2.26,1.18-5.07,1.77-8.41,1.77
            c-4.53,0-8.56-1.72-12.1-5.16c-3.54-3.44-5.31-7.62-5.31-12.54c0-3.34,1.38-6.93,4.13-10.77c2.75-3.83,6.93-7.38,12.54-10.62
            c5.61-3.24,12.49-5.95,20.65-8.11s17.75-3.24,28.77-3.24c22.61,0,38.89,4.43,48.83,13.28c9.93,8.85,14.9,22.62,14.9,41.3
            L1549.55,336.28L1549.55,336.28z M1511.2,280.82c-7.47,0.79-14.6,1.67-21.39,2.65c-6.79,0.99-11.85,1.87-15.19,2.66
            c-9.44,1.97-15.59,4.77-18.44,8.41s-4.28,7.33-4.28,11.06c0,5.12,1.57,9.1,4.72,11.95c3.14,2.85,8.55,4.28,16.23,4.28
            c12.19,0,21.63-2.8,28.32-8.41s10.03-12.83,10.03-21.68V280.82z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--quinary-color"
              d="M1611.8,422.44c-13.97,0-20.95-5.31-20.95-15.93V160.75c0-11.4,7.08-17.11,21.24-17.11
            c5.11,0,9.69,1.23,13.72,3.69s6.05,6.54,6.05,12.24v246.35c0,5.9-1.77,10.13-5.31,12.69
            C1623.01,421.16,1618.09,422.44,1611.8,422.44z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--primary-color"
              d="M1776.94,421.35h-73.84v-12.94h6.99c-5.53-5.13-8.3-11.08-8.3-17.87c0-6.41,3.12-10.5,9.36-12.3
            c-6.24-5.29-9.36-11.59-9.36-18.89c0-3.97,1.42-7.21,4.25-9.71c2.83-2.49,7.15-3.74,12.97-3.74h57.94v12.94h-57.13
            c-3.37,0-5.73,0.56-7.08,1.69c-1.35,1.14-2.01,2.75-1.96,4.84c0,3.93,1.99,7.88,5.98,11.85c0.5-0.05,1.25-0.06,2.25-0.06h57.94
            v12.87h-57.13c-3.37,0-5.73,0.56-7.08,1.69c-1.35,1.14-2.01,2.75-1.96,4.84c0,3.89,2.01,7.84,6.04,11.85h60.12V421.35z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--primary-color"
              d="M1778,311.17c0,4.44-0.61,8.14-1.84,11.08c-1.22,2.94-3.14,5.24-5.73,6.89c-2.6,1.64-5.63,2.8-9.11,3.46
            c-3.47,0.66-7.74,1-12.81,1h-16.9c-5.11,0-9.42-0.36-12.94-1.06c-3.51-0.7-6.55-1.89-9.1-3.55c-2.56-1.67-4.44-3.96-5.65-6.89
            c-1.21-2.93-1.81-6.54-1.81-10.86c0-2.68,0.25-5.08,0.74-7.17c0.5-2.09,1.19-3.89,2.06-5.41c0.88-1.51,2.05-2.81,3.52-3.87
            c1.47-1.07,3.04-1.93,4.67-2.6c1.65-0.66,3.64-1.18,5.99-1.57c2.36-0.39,4.69-0.64,7.02-0.77c2.33-0.13,5.05-0.19,8.17-0.19
            l5.98,0.06v29.85h9.85c0.17,0,0.44,0,0.81,0c2.08,0,3.62-0.01,4.62-0.03s2.29-0.11,3.9-0.26c1.6-0.14,2.8-0.39,3.59-0.73
            c0.79-0.34,1.62-0.81,2.49-1.41c0.87-0.59,1.49-1.38,1.84-2.34c0.36-0.96,0.53-2.12,0.53-3.49c0-3.04-1.01-5.09-3.03-6.18
            c-2.01-1.09-5.06-1.64-9.13-1.64h-4.49v-13.71h2.87C1770.04,289.77,1778,296.91,1778,311.17z M1732.84,319.56v-16.08h-6.67
            c-1.95,0-3.59,0.05-4.93,0.16c-1.33,0.11-2.62,0.32-3.87,0.64s-2.22,0.76-2.93,1.31c-0.71,0.56-1.27,1.32-1.69,2.28
            c-0.41,0.96-0.62,2.12-0.62,3.49c0,3.33,1.16,5.53,3.49,6.6c2.32,1.07,6.73,1.6,13.22,1.6L1732.84,319.56L1732.84,319.56z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--primary-color"
              d="M1778,259.34c0.04,6.58-2.27,11.39-6.93,14.45c-4.66,3.05-12.36,4.58-23.13,4.58h-14.35
            c-3.66,0-6.93-0.14-9.79-0.42c-2.87-0.28-5.7-0.84-8.51-1.67c-2.8-0.83-5.14-1.91-6.98-3.23c-1.85-1.32-3.35-3.11-4.49-5.35
            c-1.15-2.24-1.71-4.86-1.71-7.84c0-4.57,1.91-8.78,5.73-12.62h-34.3v-14.03h103.4v14.03h-4.74
            C1776.06,250.91,1778,254.95,1778,259.34z M1767.21,255.82c0-2.73-0.91-5.59-2.74-8.58h-48.4c-2.16,3.08-3.25,6.02-3.25,8.84
            c0,5.51,5.14,8.26,15.41,8.26h20.89c2.32,0,4.3-0.05,5.92-0.16c1.63-0.1,3.25-0.33,4.9-0.67c1.64-0.34,2.95-0.81,3.93-1.41
            c0.98-0.59,1.78-1.43,2.4-2.5C1766.9,258.54,1767.21,257.27,1767.21,255.82z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--primary-color"
              d="M1692.19,218.09h-14.35V204h14.35V218.09z M1776.94,218.09h-73.84v-14.03h73.84V218.09z" />
        <path v-if="showBrandName"
              class="logo__brand-name logo--primary-color"
              d="M1778,175.43c0,4.32-1.74,7.94-5.21,10.86s-7.45,4.39-11.95,4.39c-3.49,0-6.66-0.59-9.51-1.76
            c-2.84-1.17-5.14-2.42-6.89-3.74s-3.56-3.62-5.46-6.89c-1.89-3.27-3.23-5.8-4.02-7.59s-2.08-4.93-3.87-9.42
            c-0.12-0.26-0.21-0.45-0.25-0.58h-5.3c-4.79,0-8.18,0.5-10.2,1.51c-2.01,1-3.02,3.04-3.02,6.12c0,5.3,3.49,7.94,10.47,7.94h3.68
            l-0.5,13.9c-0.75,0-1.67-0.04-2.74-0.13c-7.36-0.43-12.73-2.54-16.09-6.34c-3.37-3.8-5.05-9.24-5.05-16.33
            c0-7.3,1.94-12.58,5.83-15.82c3.89-3.25,9.75-4.87,17.55-4.87h33.75c5.57,0,11.47-0.43,17.71-1.28v12.81
            c-4.11,0.9-7.75,1.51-10.92,1.86c3.33,1.07,6.16,2.89,8.48,5.48C1776.84,168.12,1778,171.42,1778,175.43z M1766.15,169.86
            c0-1.79-0.68-3.55-2.05-5.29c-1.37-1.73-2.73-3.02-4.06-3.87h-20.89c2.7,4.91,4.7,8.16,5.99,9.74c3.25,4.1,7.09,6.15,11.54,6.15
            c2.99,0,5.32-0.58,6.98-1.73C1765.32,173.7,1766.15,172.03,1766.15,169.86z" />
    </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: "InfernalMediaLogo",
    props: {
        id: {
            type: String,
            default: 'infernalMediaLogo',
        },
        showBrandName: {
            type: Boolean,
            default: true,
        },
        variant: {
            type: String,
            default: '',
        },
        customViewBox: {
            type: String,
            default: '1783 512',
        },
        width: {
            type: String,
            default: '100%',
        },
        height: {
            type: String,
            default: '100%',
        },
        title: {
            type: String,
            default: 'Infernal Media logo',
        },
    },
    computed: {
        cssClass(): string {
            return this.variant
                ? 'infernal-media-logo infernal-media-logo--' + this.variant
                : 'infernal-media-logo';
        },
        viewBox(): string {
            return '0 0 ' + this.customViewBox;
        },
    },
});
</script>

<style lang="scss" scoped>
.infernal-media-logo {
    /* Variables CSS */
    --infernal-color--primary: #00a1e0;
    --infernal-color--primary-dark: #004785;
    --infernal-color--secondary: #cd0e2e;
    --infernal-color--secondary-dark: #7a2430;
    --infernal-color--ternary: #b1b4b3;
    --infernal-color--ternary-dark: #6b6b6b;
    --infernal-color--quaternary: #dcdcdc;
    --infernal-color--quinary: #6e7781;

    .logo {
        &--ternary-color {
            fill: var(--infernal-color--ternary);
        }

        &--quinary-color {
            fill: var(--infernal-color--quinary);
        }

        &--secondary-color {
            fill: var(--infernal-color--secondary);
        }

        &--secondary-dark-color {
            fill: var(--infernal-color--secondary-dark);
        }

        &--primary-color {
            fill: var(--infernal-color--primary);
        }

        &--primary-dark-color {
            fill: var(--infernal-color--primary-dark);
        }
    }

    &--light {
        .logo {

            &--ternary-color,
            &--secondary-color,
            &--secondary-dark-color,
            &--primary-color,
            &--quinary-color,
            &--primary-dark-color {
                fill: var(--dealer-secondary-color);
            }
        }

        path {
            transition: fill 0.6s ease-in-out;
        }

        &:hover .logo {
            &--ternary-color {
                fill: var(--infernal-color--ternary);
            }

            &--quinary-color {
                fill: var(--infernal-color--quinary);
            }

            &--secondary-color {
                fill: var(--infernal-color--secondary);
            }

            &--secondary-dark-color {
                fill: var(--infernal-color--secondary-dark);
            }

            &--primary-color {
                fill: var(--infernal-color--primary);
            }

            &--primary-dark-color {
                fill: var(--infernal-color--primary-dark);
            }

        }
    }

    &--dealership {
        .logo {

            &--ternary-color,
            &--secondary-color,
            &--quinary-color,
            &--secondary-dark-color,
            &--primary-color,
            &--primary-dark-color {
                fill: var(--infernal-media-logo-color, var(--dealer-secondary-color));
            }
        }

        path {
            transition: fill 0.6s ease-in-out;
        }

        &:hover .logo {
            &--ternary-color {
                fill: var(--infernal-color--ternary);
            }

            &--quinary-color {
                fill: var(--infernal-color--quinary);
            }

            &--secondary-color {
                fill: var(--infernal-color--secondary);
            }

            &--secondary-dark-color {
                fill: var(--infernal-color--secondary-dark);
            }

            &--primary-color {
                fill: var(--infernal-color--primary);
            }

            &--primary-dark-color {
                fill: var(--infernal-color--primary-dark);
            }

        }
    }
}
</style>
